import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CssBaseline, Container, AppBar, Toolbar, IconButton, Typography, useTheme, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Sidebar from './components/Sidebar';
import AgarihaiCalculatePage from './pages/AgarihaiCalculatePage';
import DahaiPredictionPage from './pages/DahaiPredictionPage';
import HaiDetectionPage from './pages/HaiDetectionPage';
import HomePage from './pages/HomePage';

const drawerWidth = 240;

const App = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(!isMobile);
  const [pageTitle, setPageTitle] = useState('');

  useEffect(() => {
    // 画面サイズが変更されたときにサイドバーの開閉状態を調整
    setOpen(!isMobile);
  }, [isMobile]);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            edge="start"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            sx={{ flexGrow: 1 }}
          >
            {pageTitle}
          </Typography>
        </Toolbar>
      </AppBar>
      <Sidebar open={open} onClose={handleDrawerToggle} drawerWidth={drawerWidth} variant={isMobile ? 'temporary' : 'permanent'} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: 'background.default',
          p: 3,
        }}
      >
        <Toolbar /> {/* AppBarの高さ分のスペースを確保 */}
        <Container maxWidth="lg">
          <Routes future={{ v7_startTransition: true }}>
            <Route path="/" element={<HomePage setPageTitle={setPageTitle} />} />
            {/* /dahai-prediction への直接アクセスはデフォルトのv5にリダイレクト */}
            <Route path="/dahai-prediction" element={<Navigate to="/dahai-prediction/v5" replace />} />
            <Route path="/dahai-prediction/:modelVersion" element={<DahaiPredictionPage setPageTitle={setPageTitle} />} />
            <Route path="/agarihai-calculation" element={<AgarihaiCalculatePage setPageTitle={setPageTitle} />} />
            <Route path="/detection" element={<HaiDetectionPage setPageTitle={setPageTitle} />} />
            {/* TODO: 404 Not Found ページを追加 */}
          </Routes>
        </Container>
      </Box>
    </Box>
  );
};

export default App;
